import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import type { OrganizationEditSectionProps } from '../../types/components'

export function OrganizationEditDialogs({ ctx }: OrganizationEditSectionProps) {
  const pending = ctx.largeLogoConfirm
  return (
    <ConfirmDialog
      isOpen={pending !== null}
      title="Large File"
      message={
        pending
          ? `Please confirm, really want to continue to upload a large file\n\n${pending.file.name} - ${(pending.file.size / 1024 / 1024).toFixed(2)} MB`
          : ''
      }
      messageLayout="largeFile"
      primaryLabel="Upload"
      onPrimary={ctx.confirmLargeLogoUpload}
      secondaryLabel="Cancel"
      onSecondary={() => ctx.setLargeLogoConfirm(null)}
      onDismiss={() => ctx.setLargeLogoConfirm(null)}
      primaryFirst
    />
  )
}
